"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.other = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
exports.other = joi_1.default.object({
    correspondenceLanguage: joi_1.default.number()
        .min(constants_1.Language.English)
        .integer()
        .max(constants_1.Language.French)
        .required(),
    defaultStatus: joi_1.default.number()
        .min(0)
        .integer()
        .max(99)
        .required(),
    defaultStatusReason: joi_1.default.number()
        .min(0)
        .allow('')
        .optional(),
    defaultStatusComment: joi_1.default.string()
        .min(0)
        .max(1000)
        .allow('')
        .optional(),
    homeownerLoan: joi_1.default.boolean().required(),
    validLoan: joi_1.default.boolean().required(),
});
exports.default = { other: exports.other };
